import { get, forEach } from 'lodash'

export const mapAggregateProperties = (properties, aggregateLabel) => {
  if (!properties) return []
  const totalAggregateProperties = properties.map((property) => {
    const { name, options } = property
    const aggregate = get(options, 'aggregate', 'sum')
    const aggregateName =
      aggregate === 'sum' ? `Total ${name}` : `Average ${name}`
    return {
      ...property,
      name: aggregateName
    }
  })

  return [
    ...totalAggregateProperties,
    { name: 'Location count', type: 'text', visible: true },
    { name: aggregateLabel, type: 'text', visible: true }
  ]
}

export const mapAggregateH3FeatureProperties = (feature, numericProperties) => {
  const { count, ...rest } = feature.properties || {}

  const properties = {}

  // INFO: Add Location count, Total properties to feature properties
  properties['Location count'] = count
  forEach(numericProperties, (property) => {
    const { name, options } = property

    const aggregate = get(options, 'aggregate', 'sum')
    const totalSum = get(rest, name, 0)
    const value = aggregate === 'sum' ? totalSum : totalSum / count
    const key = aggregate === 'sum' ? `Total ${name}` : `Average ${name}`

    properties[key] = value
  })

  return { ...feature, properties }
}
